// formBits — the Owner Contact form's small shared pieces (moved verbatim out of
// pages/OwnerContactFormPage.tsx so the §13 funds section renders with the SAME
// radio tiles and text fields as the rest of the form).

export function radioTileStyle(selected: boolean): React.CSSProperties {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--space-2)',
    padding: 'var(--space-3) var(--space-4)',
    border: `1px solid ${selected ? 'var(--accent)' : 'var(--border)'}`,
    borderRadius: 'var(--radius-md)',
    cursor: 'pointer',
    backgroundColor: selected ? 'var(--accent-soft)' : 'var(--surface)',
  };
}

export function TextField(props: {
  label: string;
  value: string;
  type?: string;
  placeholder?: string;
  onChange: (v: string) => void;
  onBlur?: () => void;
}): React.JSX.Element {
  return (
    <div className="field" style={{ margin: 0 }}>
      <label>{props.label}</label>
      <input
        className="input"
        type={props.type ?? 'text'}
        value={props.value}
        placeholder={props.placeholder ?? ''}
        onChange={(e) => props.onChange(e.target.value)}
        {...(props.onBlur ? { onBlur: props.onBlur } : {})}
      />
    </div>
  );
}
